/**
 * EmptyState - Estado vazio quando não há domínios
 */
import React from 'react';
import { Card, CardContent, Typography } from '@mui/material';
import { useTheme as useMuiTheme } from '@mui/material/styles';

const EmptyState = () => {
    const theme = useMuiTheme();

    return (
        <Card
            sx={{
                backgroundColor: theme.palette.background.paper,
                border: 1,
                borderColor: 'divider'
            }}
        >
            <CardContent sx={{ p: 4 }}>
                <Typography variant="h6" color="text.secondary" textAlign="center">
                    Nenhum domínio pendente encontrado
                </Typography>
                <Typography variant="body2" color="text.secondary" textAlign="center">
                    Todos os domínios foram processados ou não há novos domínios para processar.
                </Typography>
            </CardContent>
        </Card>
    );
};

export default EmptyState;
